import { FC, useEffect, useState } from "react";
import { PAGE_NUMBERS, UNLIMITED_PAGE_SIZE } from "../../lib/data";
import { useHistory, useLocation } from "react-router-dom";
import QueryString from "qs";
import config from "../../lib/config";

interface IProps {
  page?: any;
  setPage?: (page: number) => void;
  total?: number;
  url?: string;
  small?: boolean;
  pageSize?: number;
};

const Pagination: FC<IProps> = ({
  page,
  setPage,
  total = 0,
  url,
  small = false,
  pageSize,
}) => {
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const [currentPage, setCurrentPage] = useState(1);
  const size = pageSize || config.pageSize;

  useEffect(() => {
    if (isNaN(Number(page))) {
      setCurrentPage(1);
    } else {
      setCurrentPage(Number(page));
    }
  }, [page]);

  const getMaximumPage = () => {
    return Math.ceil(total / size);
  }

  const getPageNumbers = () => {
    const pageNumbers: number[] = [];
    const startPage = Math.floor((currentPage - 1) / PAGE_NUMBERS) * PAGE_NUMBERS + 1;
    const endPage = startPage + PAGE_NUMBERS - 1;

    for (let i = startPage; i <= endPage; i++) {
      if (i > getMaximumPage()) {
        break;
      }
      pageNumbers.push(i);
    }

    return pageNumbers;
  };
  
  const onSetPage = (newPage: number) => {
    if (url) {
      history.push(`${url}?${QueryString.stringify({ ...query, pageNo: newPage })}`);
    }
    setPage?.(newPage);
  };

  const getFirstPageNumber = () => {
    return getPageNumbers().at(0) || 0;
  };

  const getLastPageNumber = () => {
    return getPageNumbers().at(-1) || UNLIMITED_PAGE_SIZE;
  };

  const goToPrevPagination = () => {
    onSetPage(getFirstPageNumber() - 1);
  };
  
  const goToNextPagination = () => {
    onSetPage(getLastPageNumber() + 1);
  };
  
  // const goToPrevPage = () => {
  //   if (currentPage <= 1) {
  //     return;
  //   }
  //   onSetPage(currentPage - 1);
  // };
  
  // const goToNextPage = () => {
  //   if (currentPage >= total) {
  //     return;
  //   }
  //   onSetPage(currentPage + 1);
  // };

  return (
    <ul>
      {/* left button */}
      {getFirstPageNumber() > 1 && (
        <li onClick={() => goToPrevPagination()}>
          <button className="btn-prev" />
        </li>
      )}
      {/* page buttons */}
      {getPageNumbers().map((pageNumber: number) => (
        <li
          key={pageNumber}
          onClick={() => onSetPage(pageNumber)}
        >
          <a className={(currentPage === pageNumber ? ' active' : ' pointer')}>{pageNumber}</a>
        </li>
      ))}
      {/* right button */}
      {getLastPageNumber() < getMaximumPage() && (
        <li onClick={() => goToNextPagination()}>
          <button className="btn-next" />
        </li>
      )}
    </ul>
  );
};

export default Pagination;